import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { TranslateService } from "@ngx-translate/core";
import { of } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { ToastrService } from "../shared/toastr.service";
import { MeetBackgroundService } from "./meet-background.service";
import {
  DELETE_MEET_BACKGROUND,
  DELETE_MEET_BACKGROUND_SUCCESS,
  DeleteMeetBackgroundAction,
  DeleteMeetBackgroundFailureAction,
  DeleteMeetBackgroundSuccessAction,
  GET_MEET_BACKGROUNDS,
  GetMeetBackgroundsFailureAction,
  GetMeetBackgroundsSuccessAction,
} from "./meet-background.actions";

@Injectable()
export class MeetBackgroundEffects {
  getMeetBackgrounds$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GET_MEET_BACKGROUNDS),
      switchMap(() =>
        this.meetBackgroundService.getAll().pipe(
          map(
            (res) =>
              new GetMeetBackgroundsSuccessAction(res.meetBackgrounds ?? []),
          ),
          catchError((err) => of(new GetMeetBackgroundsFailureAction(err))),
        ),
      ),
    ),
  );

  deleteMeetBackground$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DELETE_MEET_BACKGROUND),
      switchMap((action: DeleteMeetBackgroundAction) =>
        this.meetBackgroundService.remove(action.payload).pipe(
          map(() => new DeleteMeetBackgroundSuccessAction(action.payload)),
          catchError((err) => of(new DeleteMeetBackgroundFailureAction(err))),
        ),
      ),
    ),
  );

  deleteMeetBackgroundSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DELETE_MEET_BACKGROUND_SUCCESS),
        tap(() => {
          this.toastr.success(
            this.translate.instant("meetBackground.deleted") as string,
          );
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private meetBackgroundService: MeetBackgroundService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {}
}
